import { faLeaf, faLock, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useRef, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import { ErrorMessage } from "../..";
import { useAuth } from "../../../core";
import { LoadingButton } from "../../atoms/LoadingButton";
import { useStyles } from "./styles";
import { useTheme } from "react-jss";

import {
  digitsFaToEn,
  phoneNumberValidator,
} from "@persian-tools/persian-tools";
import { authenticationContext } from "./Authentication";

const Login = () => {
  const { state } = useLocation();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();
  const { error: loginError, loading, setError: setAuthError } = useAuth();
  const passRef = useRef();
  const theme = useTheme();
  const styles = useStyles({ theme });
  const auth = useAuth();
  const { cellnum, setCellnum } = useContext(authenticationContext);
  const { isSaderatCustomization } = JSON.parse(
    sessionStorage.getItem("config")
  );

  const handleLogin = (e) => {
    e.preventDefault();
    if (!cellnum) {
      setError("شماره موبایل را وارد کنید");
    } else if (!phoneNumberValidator(cellnum)) {
      setError("شماره موبایل معتبر وارد کنید");
      return;
    } else if (!password) {
      setError("کلمه عبور را وارد کنید");
    } else if (cellnum && password) {
      auth.login(cellnum, password, history);
    }
  };
  const loginByEnter = (e) => {
    if (e.charCode === 13) {
      e.preventDefault();
      e.target.blur();
      handleLogin(e);
    }
  };
  const enterMobile = (e) => {
    if (e.charCode === 13) {
      e.preventDefault();
      passRef.current.focus();
    }
  };
  useEffect(() => {
    setAuthError("");
  }, []);

  console.log("root");
  useEffect(() => {
    console.log("useEffect");
    if (process.env.REACT_APP_AUTO_LOGIN === "true") {
      console.log("if");
      auth.login("guest_technoland", "D3bfHhI8", history);
    }
  }, []);

  useEffect(() => {
    setError("");
  }, [cellnum, password]);
  useEffect(() => {
    setError(loginError);
  }, [loginError]);

  if (process.env.REACT_APP_AUTO_LOGIN) {
    console.log("if (process.env.REACT_APP_AUTO_LOGIN)");
    return (
      <div
        style={{
          position: "fixed",
          background: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
          top: 0,
          left: 0,
        }}
      >
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <Form className={styles.form}>
      <span className={styles.login100FormTitle}>
        {isSaderatCustomization ? "دستیار هوشمند بانکی شرکت الگوریتم" : "ورود"}
        <span className={styles.successMessage}>{state?.message}</span>
      </span>
      <div className={styles.content}>
        <div className={styles.inputsContainer}>
          <div
            className={styles.wrapInput100}
            data-validate="Valid email is required: ex@abc.xyz"
          >
            <Form.Control
              value={cellnum}
              className={styles.input100}
              placeholder="شماره موبایل"
              type="number"
              onChange={(e) => setCellnum(digitsFaToEn(e.target.value))}
              onKeyPress={enterMobile}
            />
            <span className={styles.symbolInput}>
              <FontAwesomeIcon icon={faPhone} />
            </span>
          </div>
          <div
            className={styles.wrapInput100}
            data-validate="Password is required"
          >
            <Form.Control
              placeholder="کلمه عبور"
              onChange={(e) => setPassword(e.target.value)}
              className={styles.input100}
              type="password"
              autoComplete="new-password"
              onKeyPress={loginByEnter}
              ref={passRef}
            />

            <span className={styles.symbolInput}>
              <FontAwesomeIcon icon={faLock} />
            </span>
          </div>
        </div>
        <div className={styles.footer}>
          <ErrorMessage>{error}</ErrorMessage>
          <div className={styles.containerLogin100FormBtn}>
            <LoadingButton onClick={handleLogin} {...{ loading }}>
              ورود
            </LoadingButton>
          </div>
          <div className="text-center p-t-12 d-flex justify-content-between">
            <Link to={"forget-password"} className={styles.linkText}>
              فراموشی کلمه عبور
            </Link>
            <Link to={"/register"} className={styles.linkText}>
              ثبت نام
            </Link>
          </div>
        </div>
      </div>
    </Form>
  );
};

export { Login };
